import { render, staticRenderFns } from "./ViewMp4.vue?vue&type=template&id=1b9e4f6f&"
import script from "./ViewMp4.vue?vue&type=script&lang=js&"
export * from "./ViewMp4.vue?vue&type=script&lang=js&"
import style0 from "./ViewMp4.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports